module.exports = __webpack_public_path__ + "static/improve-business-icon-225626df7e5dd36489d22ed83438333a.png";